import { assetUrl } from '../app-path';
// Only application page entries declared by migrated templates can initialize.
__webpack_public_path__ = assetUrl('/dist/');
const pages = {
  "AdvertiseWithUs": () => import(/* webpackChunkName: "legacy-advertise-with-us" */ './pages/advertise-with-us'),
  "Airport": () => import(/* webpackChunkName: "legacy-airport" */ './pages/airport'),
  "Alert": () => import(/* webpackChunkName: "legacy-alert" */ './pages/alert'),
  "Article": () => import(/* webpackChunkName: "legacy-article" */ './pages/article'),
  "Beach": () => import(/* webpackChunkName: "legacy-beach" */ './pages/beach'),
  "Brazil": () => import(/* webpackChunkName: "legacy-brazil" */ './pages/brazil'),
  "Careers": () => import(/* webpackChunkName: "legacy-careers" */ './pages/careers'),
  "Charts": () => import(/* webpackChunkName: "legacy-charts" */ './pages/charts'),
  "Climatology": () => import(/* webpackChunkName: "legacy-climatology" */ './pages/climatology'),
  "Email": () => import(/* webpackChunkName: "legacy-email" */ './pages/email'),
  "Faq": () => import(/* webpackChunkName: "legacy-faq" */ './pages/faq'),
  "Feedback": () => import(/* webpackChunkName: "legacy-feedback" */ './pages/feedback'),
  "Forecast": () => import(/* webpackChunkName: "legacy-forecast" */ './pages/forecast'),
  "Index": () => import(/* webpackChunkName: "legacy-index" */ './pages/index'),
  "JoinUs": () => import(/* webpackChunkName: "legacy-join-us" */ './pages/join-us'),
  "JoinUsSend": () => import(/* webpackChunkName: "legacy-join-us-send" */ './pages/join-us-send'),
  "Maps": () => import(/* webpackChunkName: "legacy-maps" */ './pages/maps'),
  "News": () => import(/* webpackChunkName: "legacy-news" */ './pages/news'),
  "NewsList": () => import(/* webpackChunkName: "legacy-news-list" */ './pages/news-list'),
  "PrivacyPolicy": () => import(/* webpackChunkName: "legacy-privacy-policy" */ './pages/privacy-policy'),
  "Radar": () => import(/* webpackChunkName: "legacy-radar" */ './pages/radar'),
  "Radio": () => import(/* webpackChunkName: "legacy-radio" */ './pages/radio'),
  "ResponseStatusCode": () => import(/* webpackChunkName: "legacy-response-status-code" */ './pages/response-status-code'),
  "Satellite": () => import(/* webpackChunkName: "legacy-satellite" */ './pages/satellite'),
  "Settings": () => import(/* webpackChunkName: "legacy-settings" */ './pages/settings'),
  "Summer": () => import(/* webpackChunkName: "legacy-summer" */ './pages/summer'),
  "SummerList": () => import(/* webpackChunkName: "legacy-summer-list" */ './pages/summer-list'),
  "TermsOfUse": () => import(/* webpackChunkName: "legacy-terms-of-use" */ './pages/terms-of-use'),
  "Tide": () => import(/* webpackChunkName: "legacy-tide" */ './pages/tide'),
  "Travel": () => import(/* webpackChunkName: "legacy-travel" */ './pages/travel'),
  "TravelArticle": () => import(/* webpackChunkName: "legacy-travel-article" */ './pages/travel-article'),
  "TravelInternacional": () => import(/* webpackChunkName: "legacy-travel-internacional" */ './pages/travel-internacional'),
  "TravelList": () => import(/* webpackChunkName: "legacy-travel-list" */ './pages/travel-list'),
  "Uv": () => import(/* webpackChunkName: "legacy-uv" */ './pages/uv'),
  "VideoCategory": () => import(/* webpackChunkName: "legacy-video-category" */ './pages/video-category'),
  "VideoLive": () => import(/* webpackChunkName: "legacy-video-live" */ './pages/video-live'),
  "VideoMain": () => import(/* webpackChunkName: "legacy-video-main" */ './pages/video-main'),
  "VideoPlayer": () => import(/* webpackChunkName: "legacy-video-player" */ './pages/video-player'),
  "VideoSearch": () => import(/* webpackChunkName: "legacy-video-search" */ './pages/video-search'),
  "Widget": () => import(/* webpackChunkName: "legacy-widget" */ './pages/widget'),
  "Wind": () => import(/* webpackChunkName: "legacy-wind" */ './pages/wind'),
  "Winter": () => import(/* webpackChunkName: "legacy-winter" */ './pages/winter'),
  "World": () => import(/* webpackChunkName: "legacy-world" */ './pages/world'),
};
const pending = new WeakMap();
export function initializeLegacyPages(root=document) {
  const elements=Array.from(root.querySelectorAll('[data-legacy-controller]'));
  return Promise.all(elements.map(element=>{
    if(pending.has(element))return pending.get(element);
    const load=pages[element.dataset.legacyController];
    if(!load){element.dataset.legacyState='unregistered';return Promise.resolve();}
    element.dataset.legacyState='loading';
    const promise=load().then(page=>page.initialize(element)).then(()=>{
      element.dataset.legacyState='ready';element.dispatchEvent(new CustomEvent('legacy-page-ready',{bubbles:true}));
    }).catch(()=>{
      element.dataset.legacyState='failed';element.dispatchEvent(new CustomEvent('legacy-page-error',{bubbles:true}));
      console.error('Application page initialization failed: '+element.dataset.legacyController);
    });
    pending.set(element,promise);return promise;
  }));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeLegacyPages(),{once:true});
else initializeLegacyPages();
